export default {
  INITIAL_SETTINGS_APPLIED_PROPERTY_NAME: 'initialSettingsApplied',
};
